if (!customElements.get('product-card-carousel')) {
  customElements.define(
    'product-card-carousel',
    class ProductCardCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-carousel-track]');
        this.slides = this.querySelectorAll('[data-carousel-slide]');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (!this.track || this.slides.length < 2) return;

        this.prevButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goToSlide(-1);
        });

        this.nextButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.goToSlide(1);
        });

        this.track.addEventListener(
          'scroll',
          () => {
            window.requestAnimationFrame(() => this.updateButtons());
          },
          { passive: true }
        );

        this.updateButtons();
      }

      goToSlide(direction) {
        const distance = this.track.clientWidth;

        this.track.scrollBy({
          left: distance * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      updateButtons() {
        if (!this.prevButton || !this.nextButton) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;

        this.prevButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
      }
    }
  );
}